import Vue from 'vue'
import Vuex from 'vuex'
import { apiUrl } from './app/config';
import { log } from "./app/helpers";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeCategory: null,
    bodyClass: null,
    lastRoute: null,
    hasHeader: true, // show/hide default header
    DEBUG: true,
    apiUrl: apiUrl,
    isProgressBar: true,
    user: {},
    avatar: '',
  },
  mutations: {
    switchCategory (state, n) {
      state.activeCategory = n;
    },
    bodyClass(state, className) {
      state.bodyClass = className;
    },
    lastRoute(state, n) {
      state.lastRoute = n
    },
    hasHeader(state, n) {
      state.hasHeader = n;
    },
    isProgressBar(state, n) {
      state.isProgressBar = n;
    },
    user(state, n) {
      state.user = n;
    },
    avatar(state, n) {
      state.avatar = n;
      log('updated avatar', state.avatar, n);
    }
  },
  actions: {
    
  },
  getters: {
  },
})
